<template>
  <path
    d="M15.67 4.00024H14V3.00024C14 2.45024 13.55 2.00024 13 2.00024H11C10.45 2.00024 10 2.45024 10 3.00024V4.00024H8.33C7.6 4.00024 7 4.60024 7 5.33024V20.6602C7 21.4002 7.6 22.0002 8.34 22.0002H15.66C16.4 22.0002 17 21.4002 17 20.6702V5.33024C17 4.60024 16.4 4.00024 15.67 4.00024ZM14.61 13.2402L11.94 18.2402C11.7 18.6902 11 18.5202 11 18.0002V14.5002H9.83C9.45 14.5002 9.21 14.1002 9.39 13.7602L12.06 8.76024C12.3 8.31024 13 8.48024 13 9.00024V12.5002H14.17C14.54 12.5002 14.79 12.9002 14.61 13.2402Z"
  />
</template>
